"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

/**
 * Off to sign-in and back again: `pathname + search` as the callback, matching
 * `proxy.ts`'s own `loginUrl.searchParams.set("callbackUrl", `${pathname}${request.nextUrl.search}`)`
 * — a query-only difference (a filter, a page number, a token) was otherwise
 * silently dropped on this entry point while the middleware's own redirect
 * kept it. Used by the v2 SignInPrompt (the legacy LoginRedirectModal, its first
 * user, is deleted with the last legacy comment section).
 */
export function useLoginRedirect(lang) {
  const $ = _c(5);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== lang || $[1] !== pathname || $[2] !== router || $[3] !== searchParams) {
    t0 = () => {
      const query = searchParams?.toString();
      const target = `${pathname || `/${lang}`}${query ? `?${query}` : ""}`;
      router.push(`/${lang}/auth/login?callbackUrl=${encodeURIComponent(target)}`);
    };
    $[0] = lang;
    $[1] = pathname;
    $[2] = router;
    $[3] = searchParams;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}